/* eslint-disable */
import Vue from 'vue'
import VueRouter from 'vue-router'
import {store} from '@/integrations/store'

/**
 * IMPORT ROUTES FOR ALL PAGES
 * Path being matched: @/pages/<pagename>/routes/index.js
 * Make sure to follow this path in order for auto-import to work
 * Always export const <pagename><Array> = [paths_object<Object>]
 */

const requireRoutes = require.context('@/pages', true, /routes\/.*\.js$/)
const routesUnparsed = []
const routes = []

requireRoutes.keys().forEach(key => {
  routesUnparsed.push(requireRoutes(key))
})

routesUnparsed.forEach(el => {
  Object.keys(el).forEach(key => {
    el[key].forEach(route => {
      if (process.env.NODE_ENV === 'development' && route.meta && route.meta.dev) routes.push(route)
      else if (process.env.NODE_ENV !== 'development' && route.meta && !route.meta.dev) routes.push(route)
      else if (!route.meta || route.meta) routes.push(route)
    })
  })
})

Vue.use(VueRouter)

export const router = new VueRouter({
  mode: 'history',
  routes: routes
})

router.beforeEach(async (to, from, next) => {
  await store.getters['appLoaded']

  const authFlow = to.matched.some(record => record.meta.authFlow)
  const isAuthorized = store.getters['user/userLoggedIn']
  const firstModule = store.getters['user/userFirstModule']
  const returnUrl = store.getters['user/userReturnUrl']
  const isProfileCompleted = store.getters['user/userProfileCompleted']
  const profileModule = store.getters['user/userProfileModule']

  if (!isAuthorized && to.query['access-token']) {
    store.commit('user/setAccessToken', to.query['access-token'])
    return window.location.reload()
  }
  
  if (authFlow) {
    if (isAuthorized) {
      if (!isProfileCompleted) {
        if (to.name === 'profile.edit' || to.name === 'profile.networking.edit') next()
        else router.push({name: `${profileModule.type}.edit`, params: {app_module_id: profileModule.app_module_id}})
      } else {
        if (returnUrl) {
          store.commit('user/deleteReturnUrl')
          next(returnUrl)
        } else {
          next({name: `${firstModule.type}.index`, params: {app_module_id: firstModule.app_module_id}})
        }
      }
    } else next()
  } else {
    if (isAuthorized) {
      if (!isProfileCompleted) {
        if (to.name === 'profile.edit' || to.name === 'profile.networking.edit') next()
        else router.push({name: `${profileModule.type}.edit`, params: {app_module_id: profileModule.app_module_id}})
      } else if (to.name === null) {
        if (returnUrl) {
          store.commit('user/deleteReturnUrl')
          next(returnUrl)
        } else {
          next({name: `${firstModule.type}.index`, params: {app_module_id: firstModule.app_module_id}})
        }
      } else {
        if (returnUrl) {
          store.commit('user/deleteReturnUrl')
          next(returnUrl)
        } else {
          next()
        }
      }
    } else {
      if (to.fullPath !== '/' && !to.fullPath.split('/').includes('login') && !to.fullPath.split('/').includes('logout')) store.commit('user/setReturnUrl', to.fullPath)
      next({name: 'auth.index'})
    }
  }
})

router.afterEach(async (to, from) => {
  await store.getters['user/menuLoaded']
  store.commit('layout/setHeaderLoadedState', false)
  store.commit(
    'user/setCurrentModule',
    store.getters['user/userMenu'].find(el => el.app_module_id == to.params.app_module_id)
  )
  const toModuleId = to.params && to.params.app_module_id
  const fromModuleId = from.params && from.params.app_module_id
  const history = store.getters['history']
  let isBack

  if (history) {
    if (history.length === 0 || history.length === 1) {
      store.commit('pushHistory', to)
      isBack = false
    } else {
      if (history[history.length - 2].path === to.path) {
        store.commit('popHistory')
        isBack = true
      } else {
        store.commit('pushHistory', to)
        isBack = false
      }
    }
  }

  if (fromModuleId) {
    if (
      +fromModuleId !== +toModuleId &&
      to.name !== 'profile.index' &&
      to.name !== 'profile.other' &&
      from.name !== 'profile.index' &&
      from.name !== 'profile.other'
    ) {
      store.commit('purgeCache')
    } else {
      if (isBack) {
        store.commit('popCache')
      }
    }
  }
})
